import { Layout, Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { key: "compliance", title: "Compliance Programs", path: "/compliance-programs" },
  { key: "deliverables", title: "Deliverables", path: "/deliverables" },
];

const LogoHeader = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const location = useLocation();

  const isActiveNavItem = (path) => location.pathname === path;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900 && drawerVisible) {
        setDrawerVisible(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [drawerVisible]);

  return (
    <Layout.Header
      style={{
        backgroundColor: "white",
        borderBottom: "1px solid #D9D9D9",
        padding: "0",
        height: "72px",
        width: "100%",
        margin: "0",
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 24px",
          height: "100%",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
        className="header-container"
      >
        <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img src="/assets/pWinLogo.svg" alt="pWin" height={36} />
          </Link>
        </div>

        <div
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            alignItems: "center",
            overflowX: "auto",
            minWidth: 0,
          }}
          className="header-nav-wrapper desktop-nav"
        >
          <div
            style={{ display: "flex", gap: "32px" }}
            className="header-nav-container"
          >
            {navItems.map((item) => {
              const isActive = isActiveNavItem(item.path);
              return (
                <Link
                  key={item.key}
                  to={item.path}
                  className="primary-btn"
                  style={{
                    fontSize: "15px",
                    color: isActive ? "#1467FF" : "#666",
                    borderRadius: 0,
                    borderBottom: isActive ? "2px solid #1467FF" : "2px solid transparent",
                    padding: "0",
                    height: "72px",
                    display: "inline-flex",
                    alignItems: "center",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                    fontWeight: 400,
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.title}
                </Link>
              );
            })}
          </div>
        </div>

        <div
          className="header-hamburger"
          style={{
            marginLeft: "auto",
            display: "none",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: 26 }} />}
            onClick={() => setDrawerVisible(true)}
            style={{ border: "none", boxShadow: "none" }}
          />
        </div>

        <Drawer
          title={null}
          placement="right"
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          bodyStyle={{ padding: 0 }}
          closeIcon={null}
        >
          <div
            style={{ position: "relative", width: "100%", minHeight: "100vh" }}
          >
            <Button
              type="text"
              onClick={() => setDrawerVisible(false)}
              style={{
                position: "absolute",
                top: 24,
                left: 24,
                fontSize: 32,
                border: "none",
                boxShadow: "none",
                background: "none",
                zIndex: 10,
                padding: 0,
                minWidth: "32px",
              }}
              aria-label="Close menu"
            >
              &#10005;
            </Button>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "32px",
                alignItems: "center",
                paddingTop: "26px",
              }}
            >
              {navItems.map((item, idx) => (
                <Link
                  key={item.key}
                  to={item.path}
                  onClick={() => setDrawerVisible(false)}
                  className="primary-btn"
                  style={{
                    fontSize: "16px",
                    color: isActiveNavItem(item.path) ? "#1467FF" : "#666",
                    textAlign: "center",
                    textDecoration: "none",
                    background: "none",
                    padding: 0,
                    width: "100%",
                    display: "block",
                    marginTop: idx === 0 ? "0px" : undefined,
                  }}
                >
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
        </Drawer>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .desktop-nav { display: none !important; }
          .header-hamburger { display: block !important; }
        }
        @media (min-width: 901px) {
          .desktop-nav { display: flex !important; }
          .header-hamburger { display: none !important; }
        }
      `}</style>
    </Layout.Header>
  );
};

export default LogoHeader;
